/**
 * This file contains some integration with the native Shopify Reviews app to style it in the context of the theme.
 */

import {Delegate} from "//radundrucksack.shop/cdn/shop/t/194/assets/vendor.min.js?v=20880576495916334881786277346";

const _transformForm = (spr) => {
  const labels = Array.from(spr.querySelectorAll('.spr-form-label')),
    buttons = Array.from(spr.querySelectorAll('.spr-form-actions .spr-button'));

  spr.querySelector('.spr-form-contact')?.classList.add('input-row');
  spr.querySelector('.spr-form-review')?.classList.add('fieldset');

  labels.forEach(label => {
    if (label.control) {
      label.className = 'floating-label';
      label.control.placeholder = ' ';

      if (label.control.tagName === 'INPUT') {
        label.control.className = 'input is-floating';
      } else if (label.control.tagName === 'TEXTAREA') {
        label.control.className = 'textarea is-floating';
        label.control.rows = 5;
      }

      label.control.insertAdjacentElement('afterend', label);
    }
  });

  buttons.forEach(button => {
    button.classList.add('button', 'button--primary', 'button--xl'); // Replace button class
  });
}

window.SPRCallbacks = {
  onProductLoad: (event, params) => {
    const spr = document.querySelector(`#shopify-product-reviews[data-id="${params.id}"]`);
    /* SPEEDSHOP FIX: Abort, wenn spr nicht existiert */
    if (!spr) return; 

    const section = spr.closest('.shopify-section--apps');
    if (!section) return;

    const headerTemplate = section.querySelector('#shopify-reviews-custom-header');
    if (!headerTemplate) return;

    spr.classList.add('custom-spr');
    spr.prepend(headerTemplate.content.cloneNode(true));
  },

  onReviewsLoad: (event, params) => {
    const spr = document.querySelector(`#shopify-product-reviews[data-id="${params.id}"]`);
    if (!spr) return;

    const reviewsContainer = spr.querySelector('.spr-reviews');
    
    /* SPEEDSHOP FIX: Der DebugBear-Killer. Null-Check für reviewsContainer UND den Form-Container */
    if (reviewsContainer && reviewsContainer.childElementCount === 0) {
      const form = spr.querySelector('.spr-form');
      if (form) form.style.display = 'block';
    }
  },

  onFormLoad: (event, params) => {
    const spr = document.querySelector(`#shopify-product-reviews[data-id="${params.id}"]`);
    if (spr) _transformForm(spr);
  },

  onFormSuccess: (event, params) => {
    const spr = document.querySelector(`#shopify-product-reviews[data-id="${params.id}"]`);
    if (!spr) return;
    
    const successMsg = spr.querySelector('.spr-form-message-success');
    if (successMsg) successMsg.className = 'spr-form-banner banner banner--success justify-center';
  },

  onFormFailure: (event, params) => {
    const spr = document.querySelector(`#shopify-product-reviews[data-id="${params.id}"]`);
    if (!spr) return;

    const errorMsg = spr.querySelector('.spr-form-message-error');
    if (errorMsg) errorMsg.className = 'spr-form-banner banner banner--error justify-center';
    _transformForm(spr); 
  }
}

class CustomSprHeader extends HTMLElement {
  constructor() {
    super();

    this._delegate = new Delegate(this);
    this._delegate.on('click', 'button', this._toggleForm.bind(this));
  }

  _toggleForm() {
    if (parseInt(this.getAttribute('review-count')) === 0) {
      return; /* We never want to hide the form when no review */
    }

    SPR.toggleForm(this.getAttribute('product-id'));
  }
}

if (!window.customElements.get('custom-spr-header')) {
  window.customElements.define('custom-spr-header', CustomSprHeader);
}